import React from "react";
import ErrorBoundary from "../../../../../../ErrorBoundary";
import LoadingBoundary from "@ui/LoadingBoundary";

const SuspenseSidePanel = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary>
    <LoadingBoundary>{children}</LoadingBoundary>
  </ErrorBoundary>
);

export default SuspenseSidePanel;
